import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// Règles de Bootstrap encore utilisées (tour 65, Bootstrap n'est plus installé)
import "./bootstrapUtilise.css";
import "./index.css";
// 🔒 Polices et scripts servis par le site (plus d'appel à Google Fonts ni à jsDelivr au chargement)
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
// Gras plafonné à 600 : graisses 600 à 900 dessinées en 600 (fonts.css)
import "./fonts.css";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { DarkModeProvider } from "@rbnd/react-dark-mode"; // <-- AJOUT ICI
import auth from "./puglins/Utils/models/auth";
import { loadAnalytics } from "./helper/analytics";
import { recordVisit } from "./helper/siteVisit";
import { installIcons } from "./helper/icons";
import { preloadPage } from "./routes/preload";

// Jeton « undefined » enregistré par l'ancienne inscription par e-mail : retiré (sinon le site se
// croit connecté et renvoie sans fin entre la connexion et le tableau de bord)
auth.cleanInvalidToken();

// 📊 Mesure d'audience sans cookie (Umami), éteinte sans REACT_APP_UMAMI_URL et REACT_APP_UMAMI_WEBSITE_ID
loadAnalytics();
// 📈 Arrivée sur le site, comptée une fois par onglet pour l'entonnoir de l'admin (tour 68), sans cookie ni identifiant
recordVisit("site");

// 🎨 Icônes intégrées au site, avant le premier affichage (plus d'appel à Iconify)
installIcons();

// 🚀 Page demandée : son code téléchargé dès maintenant, pendant l'écran de chargement (routes/preload.js)
preloadPage(window.location.pathname);

ReactDOM.render(
  <Provider store={store}>
    <DarkModeProvider> {/* <-- ENGLOBE L'APPLICATION ICI */}
      <Router>
        <Switch>
          <App />
        </Switch>
      </Router>
    </DarkModeProvider>
  </Provider>,
  document.getElementById("root")
);